



































































import { Component, Vue, Prop } from 'vue-property-decorator';
import Info from './Service/Info';
import Delete from './Service/Delete';
import depForm from './form';
import accountLists from './accountLists.vue';
import doModify from './Service/DoModify';

@Component({
  components: { accountLists },
})
export default class department extends Vue {
  private loading: boolean = false;

  private depForm: Object = depForm;

  private dialogAccount: boolean = false;

  // 帳號列表
  private account: any = [];

  private department_position: any = {};

  /**
   * getInfo 取得資料
   */
  public async getInfo() {
    const getter = (await new Info().get()) as any;
    this.account = getter.account;
    this.department_position = getter.p6_department_position;
  }

  private handleClose(index: number) {
    this.account.splice(index, 1);
  }

  private pushAccount(data: any) {
    const find = this.account.find((x: any) => x.p3_ant_id === data.p3_ant_id);
    if (!find) {
      this.account.push(data);
      const msg: any = this.$t('Util.createComplete');
      this.$message.success(msg);
    }
  }

  /** 送出表單 */
  public async submitForm(formName: string) {
    const getter = (await new doModify(this.account).put()) as any;
    if (getter.data && getter.data.code === 0) {
      this.getInfo();
    }
  }

  private mounted() {
    this.$store.dispatch('setBread', {
      href: '',
      label: `${this.$t('Organization.department.position')}`,
    });
    /** 從bus偵測新增行為 */
    this.$bus.$on('save', () => {
      this.submitForm('form');
    });
    /** 從bus偵測刪除行為(複選) */
    this.$bus.$on('modify', () => {
      this.$router.push(
        `/account/manage/modify?p3_ant_id=${this.$route.query.p3_ant_id}`,
      );
    });

    this.getInfo();
  }
}
